export default __webpack_public_path__ + "52ade7f3ca4342ef0c80c0ec6f28a5ae.png";